import React, {useState} from 'react';
import {Link, useLocation} from 'react-router-dom';
import UserMenu from '../../components/UserMenu';

export default function Layout({ children }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { pathname } = useLocation();

  const linkClass = (path) =>
    `flex items-center px-6 py-3 ${
      pathname === path || (path !== '/hcm' && pathname.startsWith(path))
        ? 'bg-indigo-600 text-white'
        : 'text-gray-700 hover:bg-gray-100'
    }`;

  const handleNavClick = () => setSidebarOpen(false);

  return (
    <div className="bg-gray-100 min-h-screen">
      {sidebarOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-20 md:hidden" onClick={() => setSidebarOpen(false)} />
      )}

      <aside className={`w-64 bg-white border-r border-gray-200 text-gray-900 h-screen fixed left-0 top-0 z-30 transition-transform ${sidebarOpen ? 'translate-x-0' : '-translate-x-full'} md:translate-x-0`}>
        <div className="p-6 border-b border-gray-200">
          <img src={`${process.env.PUBLIC_URL}/images/matterking-logo.png`} alt="Matter King" className="h-16 w-auto" />
        </div>
        <nav className="mt-6">
          <Link to="/hcm" className={linkClass('/hcm')} onClick={handleNavClick}>
            <span>Employees</span>
          </Link>
          <Link to="/hcm/org-chart" className={linkClass('/hcm/org-chart')} onClick={handleNavClick}>
            <span>Org Chart</span>
          </Link>
          <Link to="/hcm/pto" className={linkClass('/hcm/pto')} onClick={handleNavClick}>
            <span>Time Off</span>
          </Link>
          <Link to="/hcm/onboarding" className={linkClass('/hcm/onboarding')} onClick={handleNavClick}>
            <span>Onboarding</span>
          </Link>
          <Link to="/hcm/reviews" className={linkClass('/hcm/reviews')} onClick={handleNavClick}>
            <span>Reviews</span>
          </Link>
          <Link to="/hcm/announcements" className={linkClass('/hcm/announcements')} onClick={handleNavClick}>
            <span>Announcements</span>
          </Link>
          <Link to="/hcm/reports" className={linkClass('/hcm/reports')} onClick={handleNavClick}>
            <span>Reports</span>
          </Link>
          <Link to="/hcm/templates" className={linkClass('/hcm/templates')} onClick={handleNavClick}>
            <span>Templates</span>
          </Link>
          <Link to="/hcm/settings" className={linkClass('/hcm/settings')} onClick={handleNavClick}>
            <span>Settings</span>
          </Link>
        </nav>
      </aside>

      <header className="bg-white shadow-sm h-16 fixed top-0 right-0 left-0 md:left-64 z-10">
        <div className="flex items-center justify-between h-full px-6">
          <div className="flex items-center gap-3">
            <button onClick={() => setSidebarOpen(true)} className="md:hidden text-gray-600 hover:text-gray-900">
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
            <h1 className="text-xl md:text-2xl font-semibold text-gray-800">Human Capital Management</h1>
          </div>
          <div className="flex items-center gap-4">
            <a href="/apps" className="flex items-center gap-1 text-gray-600 hover:text-indigo-600 font-medium">
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" />
              </svg>
              Apps
            </a>
            <UserMenu color="bg-indigo-600" />
          </div>
        </div>
      </header>

      <main className="md:ml-64 pt-16">
        <div className="p-4 md:p-6">
          {children}
        </div>
      </main>
    </div>
  );
}
